import SelectBidDropdown from '@/components/Modals/AuthModal/AbsenteeBid/pages/AbsenteeBid/components/PlaceBidForm/components/SelectBidDropdown/SelectBidDropdown';

type Props = {
    itemId: number;
};

const MaxBidSelector = ({ itemId }: Props) => {
    return (
        <SelectBidDropdown
            className="mb-xs w-full"
            disabled={false}
            itemId={itemId}
            showPlaceholderOnInit
        />
    );
};

export { MaxBidSelector };
